import { useState } from "react";
import PageHeader from "../components/PageHeader";
import { Headphones, Sparkles } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import {
  DEFAULT_RELEASE_TAB,
  RELEASE_META,
  RELEASE_NOTES,
} from "../config/releaseNotes";

function ReleaseNotesList({ sections }) {
  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      {sections.map((section) => {
        const Icon = section.icon;
        return (
          <article
            key={section.id}
            className="rounded-2xl border border-slate-200/90 bg-white p-5 shadow-sm hover:shadow-md transition-shadow"
            data-testid={`release-section-${section.id}`}
          >
            <div className="flex items-start gap-3 mb-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center">
                <Icon className="w-5 h-5 text-emerald-600" />
              </div>
              <h2 className="text-base font-semibold text-slate-900 leading-snug pt-1.5">
                {section.title}
              </h2>
            </div>
            <ul className="space-y-2">
              {section.items.map((item) => (
                <li
                  key={item}
                  className="flex gap-2 text-sm text-slate-600 leading-relaxed"
                >
                  <span className="text-emerald-500 mt-1.5 flex-shrink-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </article>
        );
      })}
    </div>
  );
}

export default function NovitaAggiornamenti() {
  const [activeTab, setActiveTab] = useState(DEFAULT_RELEASE_TAB);

  return (
    <div className="p-4 md:p-6 lg:p-8 max-w-6xl mx-auto">
      <PageHeader
        title={RELEASE_META.title}
        subtitle={RELEASE_META.subtitle}
        icon={Sparkles}
        iconContainerClassName="bg-emerald-100"
        iconClassName="text-emerald-600"
      />

      <p className="text-slate-600 text-sm sm:text-base mb-6 leading-relaxed max-w-3xl">
        {RELEASE_META.intro}
      </p>

      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="mb-8"
        data-testid="release-notes-tabs"
      >
        <TabsList className="mb-6 h-auto flex-wrap gap-1 bg-slate-100 p-1 rounded-xl">
          {RELEASE_NOTES.map((release) => (
            <TabsTrigger
              key={release.id}
              value={release.id}
              className="rounded-lg px-4 py-2 data-[state=active]:bg-white data-[state=active]:text-emerald-800 data-[state=active]:shadow-sm"
              data-testid={`release-tab-${release.id}`}
            >
              {release.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {RELEASE_NOTES.map((release) => (
          <TabsContent key={release.id} value={release.id} className="mt-0">
            <ReleaseNotesList sections={release.sections} />
          </TabsContent>
        ))}
      </Tabs>

      <div className="mt-8 rounded-2xl border border-emerald-100 bg-emerald-50/60 px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-3 flex-1">
          <div className="w-10 h-10 rounded-full bg-white border border-emerald-100 flex items-center justify-center flex-shrink-0">
            <Headphones className="w-5 h-5 text-emerald-700" />
          </div>
          <p className="text-sm text-slate-700">
            Per assistenza: utilizzare il widget di supporto nell&apos;applicazione
            o contattare il referente tecnico della vostra struttura.
          </p>
        </div>
      </div>

      <footer className="mt-8 pt-6 border-t border-slate-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm text-slate-500">
        <p>Grazie per utilizzare Affidya — Il Team Affidya</p>
        <a
          href="https://www.affidya.it"
          target="_blank"
          rel="noopener noreferrer"
          className="text-emerald-700 hover:text-emerald-800 font-medium"
        >
          www.affidya.it
        </a>
      </footer>
    </div>
  );
}
